/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedQuizEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_QUIZ_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedQuizEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedQuizEnabledSettingParser.decode(input).map(res => new TierAdvancedQuizEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedQuizEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedQuizEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedQuizEnabledSettingParser.schema();
    }
}
